export enum VersionOrigin {
  User = 'user',
  Api = 'api',
  Integration = 'integration',
  Restore = 'restore',
}
